<template>
  <main id="page" class="login">
    <b-container>
      <b-row>
        <b-col md="6" offset-md="3">
          <div class="login-panel">
            <div class="login-logo">
              <b-link :to="{name: 'home'}">
                <logo size="sm"></logo>
              </b-link>
            </div>
            <auth-login-form/>
            <p class="login-forgot">
              <b-link :to="{name: 'forgot-password'}">Forgot password?</b-link>
            </p>
            <div class="login-footer-actions">
              <b-button variant="outline-primary" size="sm" :href="applyUrl">Apply for Membership</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
export default {
  data() {
    return {
      applyUrl: `${process.env.MIX_USER_APP_URL}/auth/apply`
    }
  }
}
</script>
